// eslint-disable-next-line import/prefer-default-export
export const isSearchRequestDone = (status) =>
  status.every((st) => ['pending', 'performing'].indexOf(st) === -1);
